<div class="row" *ngIf="isComercial || isBasica">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>

                <mat-card-content *ngIf="!collapseCard">

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Tempo Descarga {{hintHourResult}}</mat-label>
                                <input matInput id="txtTempoDescarga" #txtTempoDescarga maxlength="5"
                                    formControlName="Tempo_descarga" (blur)="makeCalculationsIII()" readonly
                                    currencyMask class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-hint align="end">{{txtTempoDescarga.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Tempo_descarga)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Linha Descarga</mat-label>
                                <mat-select formControlName="Linha_descarga" disableCenteringOption
                                    (selectionChange)="makeCalculationsIII()" (selectionChange)="tonLaneHr()">
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterLinhas($event.target.value)">
                                    <mat-option *ngFor="let item of listLinhas" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">APC Ligado?</mat-label>
                                <mat-select formControlName="apc_ligado" (selectionChange)="changeApc($event)">
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterCargaTransbordo($event.target.value)">
                                    <mat-option *ngFor="let item of listCargaTransbordo" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-error>{{hasErrorFormControl(formulario.controls.apc_ligado)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Recobrimento de Rolos (%)</mat-label>
                                <input matInput formControlName="Recobrimento_rolos"
                                    [readonly]="readonlyRecobrimentosRolo" id="txtRecobrRolos" maxlength="10"
                                    #txtRecobrRolos (blur)="recobrimentoRoloIsValid()"
                                    [class.InputBlockColor]="readonlyRecobrimentosRolo">
                                <i matSuffix class="{{iconDisableField}}" *ngIf="readonlyRecobrimentosRolo"></i>
                                <i matSuffix class="{{iconEnableField}}" *ngIf="!readonlyRecobrimentosRolo"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintRecobrRolos}}
                                </mat-hint>
                                <mat-hint align="end">{{txtRecobrRolos.value.length}} / 3</mat-hint>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Controle Secagem</mat-label>
                                <input matInput id="txtCtrlSecagem" #txtCtrlSecagem maxlength="255"
                                    formControlName="Controle_secagem" readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Controle_secagem)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Secador Câmara</mat-label>
                                <input matInput id="txtSecCamara" #txtSecCamara maxlength="255"
                                    formControlName="Secador_camara" readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                                </mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Secador_camara)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Faixa de Qualidade Genética</mat-label>
                                <mat-select formControlName="Faixa_qualidade_genetica" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterFxQualGen($event.target.value)">
                                    <mat-option *ngFor="let item of listFxQualGen" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <!-- <input type="text" placeholder="Faixa de Qualidade Genética" matInput
                                    [matAutocomplete]="auto2" formControlName="Faixa_qualidade_genetica"
                                    id="txtFxQualGen" maxlength="80" #txtFxQualGen>
                                <mat-autocomplete #auto2="matAutocomplete">
                                    <mat-option *ngFor="let item of filteredFxQualGenOptions | async"
                                        [value]="item.name">
                                        {{item.name}}
                                    </mat-option>
                                </mat-autocomplete> -->
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <!-- <mat-hint align="end">{{txtFxQualGen.value.length}} / 80</mat-hint> -->
                                <mat-error>{{hasErrorFormControl(formulario.controls.Faixa_qualidade_genetica)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Status WWB</mat-label>

                                <mat-select formControlName="Status_wwb" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterStatus($event.target.value)">
                                    <mat-option *ngFor="let item of listStatus" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <!-- <input type="text" placeholder="Status WWB" matInput [matAutocomplete]="auto"
                                  formControlName="Status_wwb" id="txtStatus" maxlength="2" #txtStatus>
                              <mat-autocomplete #auto="matAutocomplete">
                                  <mat-option *ngFor="let item of filteredStatusOptions | async" [value]="item.name">
                                      {{item.name}}
                                  </mat-option>
                              </mat-autocomplete> -->
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <!-- <mat-hint align="end">{{txtStatus.value.length}} / 2</mat-hint> -->
                            </mat-form-field>
                        </div>

                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Temperatura máxima de trajeto (ºC) - colheita até
                                    chegada na usina</mat-label>
                                <input matInput id="txtTempTrajeto" #txtTempTrajeto maxlength="20"
                                    formControlName="Temp_max_trajeto" (blur)="getFormFatData()" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 1 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtTempTrajeto.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Temp_max_trajeto)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Temperatura máxima do tempo total de transporte (ºC)
                                    - colheita até o início da descarga
                                </mat-label>
                                <input matInput id="txtTempTransporte" #txtTempTransporte maxlength="20"
                                    formControlName="Temp_max_total_transporte" (blur)="getFormFatData()" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 1 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtTempTransporte.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Temp_max_total_transporte)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>
<div class="row" *ngIf="isPreBasica">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>

                <mat-card-content *ngIf="!collapseCard">
                    <!-- Vai ter campos novos Termino Pasagem Data -->
                    <!-- Vai ter campos novos Termino Pasagem Hora -->
                    <!-- Vai ter campos novos Peso liquido total -->


                    <div class="row pt-3">


                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Faixa Azul de Campo</mat-label>
                                <mat-select multiple disableCenteringOption formControlName="Fx_azul_campo"
                                    id="Fx_azul_campo" (selectionChange)="isSemFaixaAzulSelected();">
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterFxAzulCampo($event.target.value)">
                                    <mat-option *ngFor="let item of listFxAzulCampo" [value]="item.name"
                                        [enabled]="isSemFaixaAzulSelected() && item.name !== 'SEM FAIXA AZUL'">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Faixa Azul por Umidade</mat-label>
                                <mat-select formControlName="Fx_azul_umidade" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterFxUmidade($event.target.value)">
                                    <mat-option *ngFor="let item of listFxAzUmidade" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>

                                <mat-error>{{hasErrorFormControl(formulario.controls.Fx_azul_umidade)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Faixa Azul por Temperatura</mat-label>
                                <mat-select formControlName="Fx_azul_temperatura" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterFxTempe($event.target.value)">
                                    <mat-option *ngFor="let item of listFxAzTempe" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>

                                <mat-error>{{hasErrorFormControl(formulario.controls.Fx_azul_temperatura)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Faixa Azul por Tempo </mat-label>

                                <mat-select formControlName="Fx_azul_tempo_nmonitorado" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterFxTempo($event.target.value)">
                                    <mat-option *ngFor="let item of listFxAzTempo" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>

                                <mat-error>{{hasErrorFormControl(formulario.controls.Fx_azul_tempo_nmonitorado)}}
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Faixa Azul por transbordo</mat-label>

                                <mat-select formControlName="Fx_azul_transbordo" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterFxTransbordo($event.target.value)">
                                    <mat-option *ngFor="let item of listFxAzTransbordo" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>

                                <mat-error>{{hasErrorFormControl(formulario.controls.Fx_azul_transbordo)}}
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Faixa Azul Geral</mat-label>

                                <mat-select formControlName="Fx_azul_geral" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterFxGeral($event.target.value)">
                                    <mat-option *ngFor="let item of listFxAzGeral" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>

                                <mat-error>{{hasErrorFormControl(formulario.controls.Fx_azul_geral)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Faixa de Qualidade Genética</mat-label>
                                <mat-select formControlName="Faixa_qualidade_genetica" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterFxQualGen($event.target.value)">
                                    <mat-option *ngFor="let item of listFxQualGen" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <!-- <input type="text" placeholder="Faixa de Qualidade Genética" matInput
                                    [matAutocomplete]="auto2" formControlName="Faixa_qualidade_genetica"
                                    id="txtFxQualGen" maxlength="80" #txtFxQualGen>
                                <mat-autocomplete #auto2="matAutocomplete">
                                    <mat-option *ngFor="let item of filteredFxQualGenOptions | async"
                                        [value]="item.name">
                                        {{item.name}}
                                    </mat-option>
                                </mat-autocomplete> -->
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <!-- <mat-hint align="end">{{txtFxQualGen.value.length}} / 80</mat-hint> -->
                                <mat-error>{{hasErrorFormControl(formulario.controls.Faixa_qualidade_genetica)}}
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Faixa de Qualidade Física</mat-label>
                                <mat-select formControlName="Faixa_qualidade_fisica" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterFxQualFis($event.target.value)">

                                    <mat-option *ngFor="let item of listFxQualFis" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Faixa_qualidade_fisica)}}
                                </mat-error>
                            </mat-form-field>
                        </div>

                    </div>


                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>